import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CancelarOperacaoComponent } from './cancelar-operacao.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
  ],
  exports: [
    CancelarOperacaoComponent
  ],
  declarations: [CancelarOperacaoComponent]
})
export class CancelarOperacaoComponentModule {
}
